module.exports = __webpack_public_path__ + "static/media/layer8.caa67f34.jpg";